import { Operator } from './operator';

export class User {
  id: number;
  securityIdentifier: number;
  selectedOperators: Operator[];
}
